module.exports = __webpack_public_path__ + "static/media/67.6053b32a.png";